import animateNumber from './plugins/animateNumber';

const attributes = ['gkv', 'gkvyourshare', 'economyottonova', 'economyyourshare', 'businessottonova', 'businessyourshare', 'firstottonova'];

document.querySelectorAll('.dentalCalculation-block').forEach(block => {
  let nav = block.querySelector('nav'),
    calculate = block.querySelector('.calculate'),
    headline = block.querySelector('.top .text h3'),
    headlineSource = headline.querySelector('span'),
    image = block.querySelector('.top .image'),
    imageSource = image.querySelector('img');

  nav.querySelectorAll('button').forEach(button => {
    button.addEventListener('click', e => {
      if (button.classList.contains('active')) {
        return;
      }

      nav.querySelector('.active').classList.remove('active');
      button.classList.add('active');

      const data = Object.assign({}, button.dataset);

      for (let key in data) {
        if (key !== 'label' && key !== 'image') {
          if (key.startsWith('percent')) {
            let string = key.replace('percent', '').toLowerCase();
            calculate.style.setProperty('--opacity-' + string, data[key] == 0 ? 0 : 1);
            calculate.querySelectorAll('[data-' + string + ']').forEach(elem => {
              elem.classList.toggle('down', data[key] < 10);
            });
            animateNumber(
              value => calculate.style.setProperty('--percent-' + string, value + '%'),
              parseInt(getComputedStyle(calculate).getPropertyValue('--percent-' + string)),
              parseInt(data[key]),
              250
            );
          } else {
            calculate.querySelectorAll('[data-' + key + ']').forEach(elem => {
              animateNumber(
                value => {
                  if (document.documentElement.lang == 'en') {
                    elem.innerHTML = '&euro;' + Math.floor(value);
                  } else {
                    elem.innerHTML = Math.floor(value) + ' &euro;';
                  }
                },
                parseInt(elem.innerHTML.replace('€', '').replace('percent', '').trim()),
                parseInt(data[key]),
                250
              );
            });
          }
        }
      }

      let newTitle = document.createElement('span'),
        newImage = document.createElement('img');

      newTitle.textContent = data.label;

      newTitle.classList.add('new');
      newImage.classList.add('new');

      headline.appendChild(newTitle);
      headlineSource.classList.add('hide');
      newTitle.classList.add('show');

      newImage.alt = data.label;
      newImage.src = data.image;

      newImage.addEventListener('load', e => {
        image.appendChild(newImage);
        setTimeout(() => {
          headlineSource.classList.remove('hide');
          headlineSource.textContent = data.label;
          newTitle.remove();
          imageSource.alt = data.label;
          imageSource.src = data.image;
          newImage.remove();
        }, 250);
      });

      calculate.querySelectorAll('[data-tooltip-replace]').forEach(elem => {
        if (document.documentElement.lang == 'en') {
          elem._tippy.setContent(
            '<table class="calculation"><tr><th>Invoice amount</th><th>&euro;' +
              (parseInt(data.gkv) + parseInt(data.gkvyourshare)) +
              '</th></tr><tr><td>' +
              elem.dataset.tooltipPercent +
              ' refundable</td><td>&euro;' +
              (parseInt(data.gkv) + parseInt(data[elem.dataset.tooltipReplace])) +
              '</td></tr><tr><td>Public health insurance pays</td><td>- &euro;' +
              data.gkv +
              '</td></tr><tr><td>ottonova pays</td><td>&euro;' +
              data[elem.dataset.tooltipReplace] +
              '</td></tr></table>'
          );
        } else {
          elem._tippy.setContent(
            '<table class="calculation"><tr><th>Rechnungsbetrag</th><th>' +
              (parseInt(data.gkv) + parseInt(data.gkvyourshare)) +
              ' &euro;</th></tr><tr><td>' +
              elem.dataset.tooltipPercent +
              ' erstattungsfähig</td><td>' +
              (parseInt(data.gkv) + parseInt(data[elem.dataset.tooltipReplace])) +
              ' &euro;</td></tr><tr><td>GKV zahlt</td><td>- ' +
              data.gkv +
              ' &euro;</td></tr><tr><td>ottonova zahlt</td><td>' +
              data[elem.dataset.tooltipReplace] +
              ' &euro;</td></tr></table>'
          );
        }
      });
    });
  });

  let setNav = () => {
    let width = block.querySelector('ul').offsetWidth - nav.offsetWidth,
      scrollPercent = width > 0 ? (100 * nav.scrollLeft) / width : 0,
      left = scrollPercent < 2 ? 0 : 1,
      right = scrollPercent > 98 || width <= 0 ? 0 : 1;
    block.querySelector('.scroll').style.setProperty('--left-opacity', left);
    block.querySelector('.scroll').style.setProperty('--right-opacity', right);
  };

  nav.addEventListener('scroll', setNav);
  window.addEventListener('resize', setNav);
  window.addEventListener('setStickyNavigationTab', setNav);
  window.addEventListener('customLoaded', setNav);
});
